import React from "react";
import PropTypes from "prop-types";
import CustomizableStoryCard from "../../cards/customizable-story-card";
import CustomizableStoryCardSchema from "../../cards/customizable-story-card-schema";
import {
  desktop9by5VerticalH5,
  mobile9by5VerticalMobileh3,
  desktop4by3HorizontalH5,
  mobile4by3HorizontalMobileh4,
  mobileNoimgVerticalMobileh4,
  desktop2by1VerticalH5,
  desktop1by1HorizontalH5
} from "../../cards/customizable-story-card/story-card.config";
import FiveStory from "../../rows/five-story-one-ad";
import { DfpAd } from "../../atoms/dfp-ad";

import styles from "./styles.m.css";
import { PGAdwithAd } from "../ad-free";

const NineteenStories = ({ stories, accentColor, pagetype = "" }) => {
  let schemaInc = 1;
  return (
    <div className={styles.base} style={accentColor && { "--accent-color": accentColor }}>
      <FiveStory stories={stories.splice(0, 4)} />
      <div itemType="http://schema.org/ItemList" itemScope id="topStories" className={`${styles.row} row`}>
        <div className={styles["desktop-col-3"]}>
          {stories.splice(0, 1).map(story => (
            <CustomizableStoryCardSchema
              key={story.id}
              className={styles["bottom-gap-2"]}
              story={story}
              desktop={Object.assign({}, desktop9by5VerticalH5, { textWrapperPadding: "var(--space1_5) 0 0" })}
              mobile={Object.assign({}, mobile9by5VerticalMobileh3, { textWrapperPadding: "var(--space1) 0 0" })}
              schemaIncrement={schemaInc++}
            />
          ))}
          {stories.splice(0, 2).map(story => (
            <CustomizableStoryCardSchema
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop4by3HorizontalH5}
              mobile={mobile4by3HorizontalMobileh4}
              schemaIncrement={schemaInc++}
            />
          ))}
          {stories.splice(0, 1).map(story => (
            <CustomizableStoryCardSchema
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop4by3HorizontalH5}
              mobile={mobileNoimgVerticalMobileh4}
              schemaIncrement={schemaInc++}
            />
          ))}
        </div>
        <div className={styles["desktop-col-2"]}>
          <PGAdwithAd
            adId={`Vikatan2023_Mobile_SP_MID1_336x280`}
            adSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
            minHeight={280}
            adDivId="div-ad-desk-3849069-2541154-1"
            class="ad_300_250 hidden-desktop"
          />
          {stories.splice(0, 2).map(story => (
            <CustomizableStoryCardSchema
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop2by1VerticalH5}
              mobile={mobile4by3HorizontalMobileh4}
              schemaIncrement={schemaInc++}
            />
          ))}
          {stories.splice(0, 1).map(story => (
            <CustomizableStoryCardSchema
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop2by1VerticalH5}
              mobile={mobileNoimgVerticalMobileh4}
              schemaIncrement={schemaInc++}
            />
          ))}
        </div>
        <div className={styles["desktop-col-3"]}>
          {stories.splice(0, 2).map(story => (
            <CustomizableStoryCard
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop4by3HorizontalH5}
              mobile={mobileNoimgVerticalMobileh4}
            />
          ))}
          {stories.splice(0, 3).map(story => (
            <CustomizableStoryCard
              key={story.id}
              className={styles["line-separator"]}
              story={story}
              desktop={desktop4by3HorizontalH5}
            />
          ))}
        </div>
        <div className={styles["desktop-col-4"]}>
          <DfpAd
            className={`${styles.ad} ${styles["ad-row-3"]} ${styles["dynamic-rect-ad"]} hidden-mobile`}
            adtype="Vikatan_Desktop_SP_ATF_Right_300x250"
            placement={pagetype}
          />
          <div>
            {stories.splice(0, 3).map(story => (
              <CustomizableStoryCard
                key={story.id}
                className={styles["bottom-gap"]}
                style={{ "--background-color": "var(--white)" }}
                story={Object.assign({}, story, { contributors: null })}
                desktop={Object.assign({}, desktop1by1HorizontalH5, { imageToHeadlineRatio: [4, 13] })}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

NineteenStories.propTypes = {
  accentColor: PropTypes.string,
  stories: PropTypes.shape(),
  pagetype: PropTypes.string
};
NineteenStories.storyLimit = 9;

export default NineteenStories;
